import { useMutation } from "react-query";
import { CreateOfficalHolidays } from "services/workSchedule";

export default function useCreateOfficalHolidays() {
  return useMutation(
    (data:any) => CreateOfficalHolidays(data),
  );
}
